
import { defineComponent } from "vue-demi";
import { API_TNotificationsShortListItem } from "@/models/notifications";

export default defineComponent({
  name: "Notifications",

  components: {
    Accordion: () => import("@/modules/Notifications/Accordion/Accordion.vue"),
    Tabs: () => import("@/modules/Notifications/Tabs/Tabs.vue"),
    NotificationsEmpty: () => import("@/modules/Notifications/components/NotificationsEmpty.vue"),
  },

  props: {
    items: { type: Array as () => API_TNotificationsShortListItem[], default: () => [] },
    loading: { type: Boolean, default: false },
  },

  emits: ["filter-changed"],

  setup(_, { emit }) {
    function setTab(tabValue: string) {
      emit("filter-changed", tabValue);
    }

    return {
      setTab,
    };
  },
});
